import * as React from 'react';
import {useDispatch} from 'react-redux';

import {AddOnPicker} from 'shells/billing/add-ons/add-on-picker';
import type {AddOns, SelectedAddOn, BillingRoute} from 'shells/billing/types';
import {ErrorState} from 'shells/error-state/error-state';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import type {GetInvoicePreview_invoicePreview as InvoicePreview} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../../../analytics-client';
import {OpenableModals} from '../../../../openable-modals/openable-modals';
import * as actions from '../../../../openable-modals/openable-modals-actions';

import {handlePlanIsEnabledChange, handleSelectedPlanChange} from '../helpers';

import styles from '../manage.module.css';

type Props = {
    addOns: AddOns | null | undefined;
    selectedAddOns: SelectedAddOn[];
    setSelectedAddOns: any;
    errorMessage: string | null | undefined;
    route: BillingRoute;
    isTrial: boolean;
    invoicePreview: InvoicePreview | null | undefined;
};

export function ManageAddons(props: Props) {
    const {isTrial} = props;

    const dispatch = useDispatch();

    const handleOpenModal = () => {
        dispatch(actions.openModal(OpenableModals.CAMPAIGNS_ONBOARDING_MODAL));
    };

    React.useEffect(() => {
        if (isTrial)
            analyticsClient.track(
                analyticsClient.EVENTS.TRACK_CUSTOMER_TRIAL_VISITS_BILLING_ADD_ONS
            );
    }, [isTrial]);

    return (
        <div className='pad-16 flex flex-dir-col gap-24'>
            <div className={styles.title}>
                <StackLegacy spacing={8}>
                    <Body size='large' isBold={true} color='dark' as='div'>
                        Enhance your plan with add-ons
                    </Body>
                    <Body as='div'>
                        While CRM plans are priced per seat, add-ons are priced on a per-company
                        basis.
                    </Body>
                </StackLegacy>
            </div>
            {props.errorMessage && <ErrorState errorMessage={props.errorMessage} />}
            {props.addOns && (
                <AddOnPicker
                    addOns={props.addOns}
                    selectedAddOns={props.selectedAddOns}
                    setSelectedAddOns={props.setSelectedAddOns}
                    onSelectedPlanChange={handleSelectedPlanChange}
                    onPlanIsEnabledChange={handlePlanIsEnabledChange}
                    onOpenModal={handleOpenModal}
                    route={props.route}
                    invoicePreview={props.invoicePreview}
                />
            )}
        </div>
    );
}
